import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import CreatableSelect from "react-select/creatable";
import { selectStyle } from "../../../shared/fixtures/select_style";
import { PrimaryButton } from "../../atoms/Buttons";
import Select from "react-select";
import loadIcon from "../../../assets/images/tail-spin.svg";
import { H1, P } from "../../atoms/Texts";
import ModalHolder from "../../molecules/ModalHolder";
import { DarkSelectInput } from "../../atoms/Inputs";

import { toastWarning } from "../../../shared/helpers";

const EditEligibilityModal = ({ closeModal, eligibility, services }) => {
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedSituations, setSelectedSituations] = useState([]);
  const [organizationServices, setOrganizationServices] = useState([]);

  const arrangeOrganizationServices = (services) =>
    services.map((service) => ({
      label: service.name,
      value: service.id,
    }));

  const arrangeSituations = (situations) =>
    situations.split(",").map((situation) => ({
      label: situation,
      value: situation,
    }));

  const parseScreenPreference = (preference) => !!preference;

  useEffect(() => {
    if (eligibility && services) {
      setSelectedSituations(arrangeSituations(eligibility.situation));
      setSelectedServices(arrangeOrganizationServices([eligibility.service]));
      setOrganizationServices(arrangeOrganizationServices(services));
    }
  }, [eligibility, services]);

  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors: formStateErrors },
  } = useForm();

  const log = watch("autoScreen");

  const onUpdateEligibility = async (data) => {
    toastWarning("Can not perform this action on Demo mode");
  };

  const onDeleteEligibility = async () => {
    toastWarning("Can not perform this action on Demo mode");
  };

  return (
    <ModalHolder closeModal={closeModal}>
      <section className="py-2 md:py-4">
        <div className="flex flex-col items-center">
          <H1 fontSize="26px">Edit eligibility</H1>
          <P className="mb-4 mt-2" color="#7D7B96">
            Set your available date and times here.
          </P>
        </div>
        <form onSubmit={handleSubmit(onUpdateEligibility)} className="pb-10">
          <div className="flex flex-col lg:flex-wrap">
            {selectedServices.length > 0 && (
              <div className="mb-6">
                <label htmlFor="services">
                  <P
                    fontSize="14px"
                    fontFamily="semi"
                    color="#47495C"
                    className="mb-2"
                  >
                    Services
                    <span style={{ color: "#E62250" }}> *</span>
                  </P>
                </label>
                <Controller
                  control={control}
                  name="services"
                  defaultValue={selectedServices}
                  render={({ field }) => (
                    <Select
                      {...field}
                      styles={selectStyle}
                      options={organizationServices}
                      isMulti
                      placeholder="--Add a service--"
                      className="w-full"
                      defaultValue={selectedServices}
                      isDisabled
                    />
                  )}
                  rules={{ required: true }}
                />
                {formStateErrors.services && (
                  <P fontSize="12px" className="mt-2 mb-2 text-red-400 text-sm">
                    Select a service
                  </P>
                )}
              </div>
            )}

            {selectedSituations.length > 0 && (
              <div className="mb-6">
                <label htmlFor="situation">
                  <P
                    fontSize="14px"
                    fontFamily="semi"
                    color="#47495C"
                    className="mb-2"
                  >
                    Situations
                    <span style={{ color: "#E62250" }}> *</span>
                  </P>
                </label>
                <Controller
                  control={control}
                  name="situation"
                  defaultValue={selectedSituations}
                  render={({ field }) => (
                    <CreatableSelect
                      {...field}
                      styles={selectStyle}
                      isMulti
                      options={selectedSituations}
                      placeholder="-- Add Situations --"
                      className="w-full"
                    />
                  )}
                  rules={{ required: true }}
                />
                {formStateErrors.situation && (
                  <P fontSize="12px" className="mt-2 mb-2 text-red-400 text-sm">
                    Enter at least one situation
                  </P>
                )}
              </div>
            )}

            <div>
              <DarkSelectInput
                type="select"
                id="autoScreen"
                name="autoScreen"
                label="Auto Screen Participants?"
                defaultValue={parseScreenPreference(eligibility.autoScreen)}
                required
                {...register("autoScreen", {
                  required: "Select a screen preference",
                })}
              >
                <option value="" disabled>
                  Select an option
                </option>
                <option value={true}>Yes</option>
                <option value={false}>No</option>
              </DarkSelectInput>

              <ErrorMessage
                errors={formStateErrors}
                name="autoScreen"
                as={
                  <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />
                }
              />
            </div>
            <div className="mt-8 flex justify-center">
              <PrimaryButton.Light
                disabled={deleting}
                type="button"
                className="mr-5 w-1/3"
                onClick={onDeleteEligibility}
              >
                {deleting ? (
                  <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
                ) : (
                  "Delete"
                )}
              </PrimaryButton.Light>
              <PrimaryButton disabled={loading} className="w-2/3">
                {loading ? (
                  <img src={loadIcon} alt="Loading" className="mx-auto h-6 w-6" />
                ) : (
                  "Save"
                )}
              </PrimaryButton>
            </div>
          </div>
        </form>
      </section>
    </ModalHolder>
  );
};

export default EditEligibilityModal;
